import { injectable, IAPIInterceptorContribution } from '@meego-remote/core/app/contract';
import type { AxiosRequestHeaders, AxiosStatic } from 'axios';
import { getAPIHost, isTrialDemoEnvironment } from './utils';
import { isVa } from '@meego-remote/main/base/utils';

@injectable({ implements: [IAPIInterceptorContribution] })
export class TrialDemoAPIInterceptorContribution implements IAPIInterceptorContribution {
  interceptor(axios: AxiosStatic) {
    if (!isTrialDemoEnvironment()) {
      return;
    }
    axios.interceptors.request.use(
      config => {
        const { url = '', headers = {} }: { url?: string; headers?: Record<string, string> } = config;
        if (url?.startsWith('https://') || url?.startsWith('http://')) {
          const { host } = new URL(url);
          const apiHost = getAPIHost(host);
          if (apiHost) {
            config.url = config.url?.replace(host, apiHost);
          }
        } else {
          const host = getAPIHost(location.host);
          if (host) {
            config.url = `https://${host}${config.url}`;
          }
        }

        // cors & auth
        let trialDemoSimpleName = sessionStorage.getItem('trial_demo_simple_name');
        if (!trialDemoSimpleName) {
          trialDemoSimpleName = window.location.pathname.split('/')?.[1];
        }
        const meegoTrialData = JSON.parse(
          localStorage.getItem(`meego_trial_data_${trialDemoSimpleName}`) || '{}',
        );
        headers['x-meego-trial-template-id'] = meegoTrialData?.templateId;
        headers['x-meego-trial-visitor-id'] = meegoTrialData?.visitorId;
        if (isVa) {
          headers['meego_target_unit'] = 'larksgaws';
        }
        config.withCredentials = true;
        config.headers = headers as unknown as AxiosRequestHeaders;

        return config;
      },
      err => Promise.reject(err),
    );
  }
}
